import type { ComponentProps } from "react";

import { Link } from "react-router-dom";

export type NavAnchorProps = Omit<ComponentProps<"a">, "href"> & { href: string };

/**
 * Yon panel havolasi — ilovaning o'z routeri orqali.
 *
 * Menyu komponentlari (`NavFlyout`, `NavAccordion`) admin panelida ham,
 * kabinetda ham bir xil fayl; havola esa har birida boshqa: bu yerda
 * `react-router`, kabinetda til prefiksini qo'yadigan `@/i18n/navigation`.
 * Farq faqat shu faylda qoladi. Chiziladigan narsa haqiqiy `<a href>` —
 * manzilni nusxalash va o'rta tugma brauzerning o'zida ishlaydi.
 */
export function NavAnchor({ href, ...props }: NavAnchorProps) {
  return <Link to={href} {...props} />;
}
